export const MONTHS = ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"];

export const brl = (v, opts = {}) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0, ...opts }).format(Number(v) || 0);

export const brlCents = (v) => brl(v, { maximumFractionDigits: 2, minimumFractionDigits: 2 });

export const todayISO = () => new Date().toISOString().slice(0, 10);
export const monthKey = (d = new Date()) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;

export const monthLabel = (key) => {
  const [y, m] = key.split("-").map(Number);
  return `${MONTHS[m - 1]} ${y}`;
};
export const monthName = (key) => {
  const m = Number(key.split("-")[1]);
  return MONTHS[m - 1].charAt(0).toUpperCase() + MONTHS[m - 1].slice(1);
};

export const shiftMonth = (key, delta) => {
  const [y, m] = key.split("-").map(Number);
  const d = new Date(y, m - 1 + delta, 1);
  return monthKey(d);
};

export const shortDate = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.slice(0, 10).split("-");
  return `${d}/${m}/${y.slice(2)}`;
};

export const weekStart = (d = new Date()) => {
  const date = new Date(d);
  const day = (date.getDay() + 6) % 7;
  date.setDate(date.getDate() - day);
  return date.toISOString().slice(0, 10);
};

export const greeting = () => {
  const h = new Date().getHours();
  if (h < 12) return "Bom dia";
  if (h < 18) return "Boa tarde";
  return "Boa noite";
};

export const pct = (v) => `${Math.round((v || 0) * 100)}%`;

export const parseAmount = (s) => {
  if (typeof s === "number") return s;
  const clean = String(s || "").replace(/[^\d,.-]/g, "").replace(/\./g, "").replace(",", ".");
  return Number(clean) || 0;
};
